(function () {
  if (window.StenInit && window.StenInit['sten-content-hub-multi']) return;
  window.StenInit = window.StenInit || {};
  window.StenInit['sten-content-hub-multi'] = true;

  function initSection(root) {
    if (root.dataset.stenInitialized) return;
    root.dataset.stenInitialized = 'true';

    var grid = root.querySelector('.sten-blog-grid');
    var loadMoreBtn = root.querySelector('.sten-blog-load-more-btn');
    var filters = root.querySelectorAll('.sten-blog-filter');
    if (!grid) return;

    var itemsPerPage = parseInt(grid.dataset.itemsPerPage, 10) || 12;
    var currentFilter = 'all';
    var currentPage = 1;

    // Cards arrive grouped by blog; merge them into one newest-first stream.
    var cards = Array.prototype.slice.call(grid.querySelectorAll('.sten-blog-card-wrapper'));
    cards.sort(function (a, b) {
      return (parseInt(b.dataset.timestamp, 10) || 0) - (parseInt(a.dataset.timestamp, 10) || 0);
    });
    cards.forEach(function (card) { grid.appendChild(card); });

    function cardMatches(card, filter) {
      if (filter === 'all') return true;
      if (filter === 'featured') {
        return card.dataset.contentType === 'page' && card.dataset.isFeatured === 'true';
      }
      return card.dataset.blog === filter;
    }

    function updateFilterButtons(activeFilter) {
      var nav = root.querySelector('.sten-blog-filters');
      filters.forEach(function (btn) {
        var btnFilter = btn.dataset.filter === 'blog' ? btn.dataset.blog : btn.dataset.filter;
        var isActive = btnFilter === activeFilter;
        btn.classList.toggle('sten-active', isActive);
        btn.setAttribute('aria-current', isActive ? 'page' : 'false');
        // keep the active chip in view when the filter band scrolls sideways (mobile)
        if (isActive && nav && nav.scrollWidth > nav.clientWidth) {
          var btnLeft = btn.getBoundingClientRect().left - nav.getBoundingClientRect().left + nav.scrollLeft;
          nav.scrollLeft = Math.max(0, btnLeft - (nav.clientWidth - btn.offsetWidth) / 2);
        }
      });
    }

    function applyFilter(filter) {
      currentFilter = filter;
      currentPage = 1;
      var shown = 0;

      cards.forEach(function (card) {
        if (cardMatches(card, filter)) {
          shown++;
          card.style.display = '';
          card.classList.toggle('sten-hidden', shown > itemsPerPage);
        } else {
          card.style.display = 'none';
        }
      });

      if (loadMoreBtn) {
        loadMoreBtn.style.display = shown > itemsPerPage ? '' : 'none';
        loadMoreBtn.dataset.totalItems = shown;
        loadMoreBtn.dataset.currentPage = 1;
      }

      updateFilterButtons(filter);
    }

    function syncUrl(filter) {
      if (!window.history || !window.history.replaceState) return;
      var url = new URL(window.location.href);
      if (filter === 'all') {
        url.searchParams.delete('hub');
        url.searchParams.delete('filter');
      } else if (filter === 'featured') {
        url.searchParams.set('filter', 'featured');
        url.searchParams.delete('hub');
      } else {
        url.searchParams.set('hub', filter);
        url.searchParams.delete('filter');
      }
      window.history.replaceState({}, '', url.toString());
    }

    filters.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var filter = btn.dataset.filter === 'blog' ? btn.dataset.blog : btn.dataset.filter;
        // Clicking the active filter again returns to All
        if (filter === currentFilter && filter !== 'all') filter = 'all';
        applyFilter(filter);
        syncUrl(filter);
      });
    });

    if (loadMoreBtn) {
      loadMoreBtn.addEventListener('click', function () {
        var totalItems = parseInt(this.dataset.totalItems, 10) || 0;
        currentPage++;
        var endIndex = Math.min(currentPage * itemsPerPage, totalItems);

        var visibleCount = 0;
        cards.forEach(function (card) {
          if (card.style.display !== 'none') {
            visibleCount++;
            if (visibleCount <= endIndex) {
              card.classList.remove('sten-hidden');
            }
          }
        });

        if (currentPage * itemsPerPage >= totalItems) {
          this.style.display = 'none';
        }
        this.dataset.currentPage = currentPage;
      });
    }

    // Scroll hint for the mobile filter band: show while there is more to the right
    var navWrap = root.querySelector('.sten-blog-filters-wrap');
    var navEl = root.querySelector('.sten-blog-filters');
    function updateScrollHint() {
      if (!navWrap || !navEl) return;
      var overflowing = navEl.scrollWidth > navEl.clientWidth + 1;
      var atEnd = navEl.scrollLeft + navEl.clientWidth >= navEl.scrollWidth - 8;
      navWrap.classList.toggle('sten-has-overflow', overflowing);
      navWrap.classList.toggle('sten-at-end', atEnd);
    }
    if (navEl) {
      navEl.addEventListener('scroll', updateScrollHint, { passive: true });
      window.addEventListener('resize', updateScrollHint);
      updateScrollHint();
    }

    // Deep-link support: ?hub=<blog-handle> or ?filter=featured
    var urlParams = new URLSearchParams(window.location.search);
    var initialFilter = 'all';
    if (urlParams.get('filter') === 'featured') {
      initialFilter = 'featured';
    } else if (urlParams.get('hub')) {
      initialFilter = urlParams.get('hub');
    }

    var hasMatchingButton = initialFilter === 'all';
    filters.forEach(function (btn) {
      var btnFilter = btn.dataset.filter === 'blog' ? btn.dataset.blog : btn.dataset.filter;
      if (btnFilter === initialFilter) hasMatchingButton = true;
    });
    if (!hasMatchingButton) initialFilter = 'all';

    applyFilter(initialFilter);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-section-type="sten-content-hub-multi"]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
